<template>
  <path
    d="M12.93 4.26018L19.08 19.2502C19.42 20.0802 18.57 20.9102 17.75 20.5402L12.41 18.1802C12.15 18.0702 11.86 18.0702 11.6 18.1802L6.26002 20.5402C5.44002 20.9002 4.59002 20.0802 4.93002 19.2502L11.08 4.26018C11.41 3.43018 12.59 3.43018 12.93 4.26018Z"
  />
</template>
